// ======================================================================
// File Name       : ServiceUsageSetting
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col, InputGroup } from 'react-bootstrap';
import FormControlValidate from '../../components/FormControlValidate';
import { FormControl } from '../../components/formControl';
import SelectBox from '../../components/SelectBox';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import * as ServiceConstant from '../../constants/ServiceConstant';
import { USER_TYPE } from '../../constants/UserConstants';
import { DEFAULT_SELECTED_VIDEO_SPEED_LIST, FUNCTIONAL_EXTENSION_URL, LO_SUPER_USER, MODE, VALIDATE_TYPE } from '../../constants/index';
import { copyTextToClipboard } from '../../utils/ServiceUtils';
import FileUpload from '../FileUpload';

class ServiceUsageSetting extends React.Component {
  constructor() {
    super();
    this.state = {
      isClosedVideoSetting: true,
      openOrCloseStyle: 'plus',
      isClosedSamlSetting: true,
      openOrCloseStyleForSamlSetting: 'plus',
    };
    this.validation = this.validation.bind(this);
    this.hanleOpenAndCloseVideoSetting = this.hanleOpenAndCloseVideoSetting.bind(this);
    this.hanleOpenAndCloseSamlSetting = this.hanleOpenAndCloseSamlSetting.bind(this);
    this.openFunctionalExtensionPage = this.openFunctionalExtensionPage.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  hanleOpenAndCloseVideoSetting() {
    this.setState({
      isClosedVideoSetting: !this.state.isClosedVideoSetting,
      openOrCloseStyle: this.state.isClosedVideoSetting ? 'minute' : 'plus',
    });
  }

  hanleOpenAndCloseSamlSetting() {
    this.setState({
      isClosedSamlSetting: !this.state.isClosedSamlSetting,
      openOrCloseStyleForSamlSetting: this.state.isClosedSamlSetting ? 'minute' : 'plus',
    });
  }

  // Step 13.0.0 TAS-23665 START
  openFunctionalExtensionPage() {
    const newPage = window.open(`${FUNCTIONAL_EXTENSION_URL}`, '_blank');
    newPage.focus();
  }
  // Step 13.0.0 TAS-23665 END

  render() {
    const {
      usageSettingInfo,
      handleChangeForUsageSetting,
      displayUserType,
      serviceType,
      handleChange,
      handleVideoSpeedSettingChange,
      videoSpeedArr,
      xmlUploadFile,
      mode,
      adminUiCustomize,
      ipRestriction,
      documentPrintingPermission,
      documentDownloadPermission,
      personalSettingsEditDisplay,
      progressStatusDisplay,
      learningHistoryDisplay,
      passwordResetMessageDisplay,
      videoForwardingProhibited,
      privacyPolicyDisplay,
      customizeRange,
      dormantUserDataAcquisitionPermissionFlag,
      handleChangeForServiceSetting,
      helpDisplay,
      noticeDisplay,
      messageDisplay,
      backgroundVideoPlaybackFlag, // STEP12.0.0 TAS-18197
      videoEndThreshold, // STEP13.0.0 TAS-21617
      rootFlag, // STEP13.0.0 TAS-21617
      handleChangeForVideoEndThreshold,// STEP13.0.0 TAS-21617
      isDisableByCustomizeSuf,// STEP13.0.0 TAS-21617
    } = this.props;
    this.refsToValidate = [];
    // STEP7.0 #3 START
    const isSupperUserL0 = [LO_SUPER_USER].indexOf(displayUserType) > -1;
    // STEP7.0 #3 END
    // video speed options
    const checkBoxesComponent = videoSpeedArr.map((value, index) => {
      return (
        <Col key={index} sm={3} className="padding-left-clear">
          <Form.Check
            type='checkbox'
            value={value.speed}
            id={`checkbox-${value.speed}`}
            onChange={handleVideoSpeedSettingChange}
            disabled={DEFAULT_SELECTED_VIDEO_SPEED_LIST.includes(value.speed)}
            checked={value.isChecked}
            label={`${value.speed}倍`}></Form.Check>
        </Col>
      );
    });
    // Step SAML START
    let fileName = '';
    if (xmlUploadFile && xmlUploadFile.name) {
      fileName = xmlUploadFile.name;
    }
    let fileSize = 0;
    if (xmlUploadFile && xmlUploadFile.size) {
      fileSize = xmlUploadFile.size;
    }
    // Step SAML END

    // #7494 START
    const isContentDistributionService = parseInt(serviceType, 10) === 2;
    // #7494 END

    // #7514 START
    const isDisableSamlUsageSetting = parseInt(usageSettingInfo.usageSettingSaml, 10)
      === ServiceConstant.AVAILABLE_DISABLE_USAGE.DISABLE;
    // #7514 END

    return <>
      <Form.Group className="form-info">
        <Col className="form-label" sm={12}>利用機能設定</Col>
        {mode === MODE.EDIT_MODE && rootFlag && !isContentDistributionService && (
          <Col sm={12}>
              <div className="service-functional-help">
                <a onClick={this.openFunctionalExtensionPage}>各利用機能の詳細はこちら</a>
              </div>
          </Col>
        )}
      </Form.Group>
      <Form.Group className="form-info margin-top-10">
        <Col
          as={Form.Label}
          sm={{
            span: 3,
            offset: 1
          }}>ビデオ</Col>
        <Col sm={7}>
          <Col as={Form.Label} sm={4} className="padding-left-right-clear" >利用有無</Col>
          <Col sm={8} className="padding-left-right-clear">
            <SelectBox
              name="usageSettingVideo"
              onChange={handleChangeForUsageSetting}
              data={ServiceConstant.AvailableDisableUsage}
              value={usageSettingInfo.usageSettingVideo}
              disabled={parseInt(serviceType, 10) === 2}
            />
          </Col>
        </Col>
      </Form.Group>
      {/* sprint_20230403 #5 START */}
      <Form.Group className="form-info margin-top-10 margin-bottom-0">
        <Col
          as={Form.Label}
          sm={{
            span: 3,
            offset: 1
          }}
          className="padding-left-5">
          <a role="presentation" className={this.state.openOrCloseStyle} onClick={this.hanleOpenAndCloseVideoSetting}>
            ビデオ詳細設定
          </a>
        </Col>
      </Form.Group>
      {/* sprint_20230403 #5 END */}
      {displayUserType === USER_TYPE.ADMIN && (
        <>
          {!this.state.isClosedVideoSetting && (
            <>
              <Form.Group className="form-info margin-top-10">
                <Col
                  as={Form.Label}
                  sm={{
                    span: 2,
                    offset: 2
                  }}>
                  ジョブテンプレート名
                </Col>
                <Col sm={7}>
                  <FormControlValidate
                    type="text"
                    validateType={VALIDATE_TYPE.ID_INCLUDING_HYPHEN}
                    name="videoMcJobtemplate"
                    maxLength="256"
                    label="ジョブテンプレート名"
                    onChange={handleChangeForUsageSetting}
                    value={usageSettingInfo.videoMcJobtemplate}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              </Form.Group>
            </>
          )}
        </>
      )} 
      {/* sprint_20230403 #5 START */}
      {!this.state.isClosedVideoSetting && (
        <>
          <Form.Group className="form-info">
            <Col
              sm={{
                span: 2,
                offset: 2
              }}
              as={Form.Label}>
              再生速度変更
            </Col>
            <Col sm={8}>
              {checkBoxesComponent}
            </Col>
          </Form.Group>
        </>
      )}
      {/* sprint_20230403 #5 END */}
      {/* // STEP7.0 #3 START */}
      {isSupperUserL0 && (
        <Form.Group className="form-info margin-top-10">
          <Col
            sm={{
              span: 11,
              offset: 1
            }}
            className="padding-left-20">
            <Form.Check
              type='checkbox'
              name="usageSettingSufCustomize"
              id="usageSettingSufCustomize"
              onChange={handleChange}
              checked={usageSettingInfo.usageSettingSufCustomize}
              label='サービス利用ユーザー画面をカスタマイズする'></Form.Check>
          </Col>
        </Form.Group>
      )}
      {/* // STEP7.0 #3 END */}
      {/* sprint_20230403 #4 START */}
      {isSupperUserL0 && mode === MODE.EDIT_MODE && !isContentDistributionService ? (
        <>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>管理者UIカスタマイズ</Col>
            <Col sm={7}>
              <SelectBox
                name="adminUiCustomize"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABLE_DISABLE_USAGE_BOOLEAN_VALUE}
                value={adminUiCustomize}
                disabled={parseInt(serviceType, 10) === 2}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>IPアドレス制限利用</Col>
            <Col sm={7}>
              <SelectBox
                name="ipRestriction"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABLE_DISABLE_USAGE_BOOLEAN_VALUE}
                value={ipRestriction}
                disabled={parseInt(serviceType, 10) === 2}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>ドキュメント印刷許可</Col>
            <Col sm={7}>
              <SelectBox
                name="documentPrintingPermission"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.DOCUMENT_PRINTING_PERMISSION}
                value={documentPrintingPermission}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>ドキュメントダウンロード許可</Col>
            <Col sm={7}>
              <SelectBox
                name="documentDownloadPermission"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.DOCUMENT_DOWNLOAD_PERMISSION}
                value={documentDownloadPermission}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>個人設定編集表示</Col>
            <Col sm={7}>
              <SelectBox
                name="personalSettingsEditDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={personalSettingsEditDisplay}
                parse={(value) => value === 'true'}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>進捗状況表示</Col>
            <Col sm={7}>
              <SelectBox
                name="progressStatusDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={progressStatusDisplay}
                parse={(value) => value === 'true'}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>学習履歴表示</Col>
            <Col sm={7}>
              <SelectBox
                name="learningHistoryDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={learningHistoryDisplay}
                parse={(value) => value === 'true'}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          {/* Step 10.0.0 START */}
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>ヘルプ表示</Col>
            <Col sm={7}>
              <SelectBox
                name="helpDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={helpDisplay}
                parse={(value) => value === 'true'}
                disabled={parseInt(serviceType, 10) === 2}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>お知らせ表示</Col>
            <Col sm={7}>
              <SelectBox
                name="noticeDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={noticeDisplay}
                parse={(value) => value === 'true'}
                disabled={parseInt(serviceType, 10) === 2}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>メッセージ表示</Col>
            <Col sm={7}>
              <SelectBox
                name="messageDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={messageDisplay}
                parse={(value) => value === 'true'}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          {/* Step 10.0.0 END */}
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>パスワードリセットメッセージ表示</Col>
            <Col sm={7}>
              <SelectBox
                name="passwordResetMessageDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={passwordResetMessageDisplay}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>ビデオ先送り禁止</Col>
            <Col sm={7}>
              <SelectBox
                name="videoForwardingProhibited"
                onChange={handleChangeForServiceSetting}
                // Step9.0.1 START
                data={SELECT_BOX_DATA.AVAILABLE_DISABLE_USAGE_BOOLEAN_VALUE}
                // Step9.0.1 END
                value={videoForwardingProhibited}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          {/* Step8.0.3 START */}
          {/* STEP12.0.0 TAS-18197 START */}
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>
              バックグラウンド再生フラグ
            </Col>
            <Col sm={7}>
              <SelectBox
                name="backgroundVideoPlaybackFlag"
                onChange={handleChangeForServiceSetting}
                data={
                  SELECT_BOX_DATA.BACKGROUND_VIDEO_PLAYBACK_FLAG
                }
                value={backgroundVideoPlaybackFlag}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf} // STEP13.0.0 TAS-23260
              />
            </Col>
          </Form.Group>
            {/* STEP12.0.0 TAS-18197 END */}
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>プライバシーポリシー表示</Col>
            <Col sm={7}>
              <SelectBox
                name="privacyPolicyDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={privacyPolicyDisplay}
                disabled={parseInt(serviceType, 10) === 2}
              />
            </Col>
          </Form.Group>
          {/* Step8.0.3 END */}
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>カスタマイズ範囲</Col>
            <Col sm={7}>
              <FormControlValidate
                label="カスタマイズ範囲"
                type="text"
                name="customizeRange"
                value={customizeRange || ''}
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                    if (ref.value !== '') {
                      ref.validation();
                    }
                  }
                }}
                onChange={handleChange}
                maxLength="512" // sprint_20230403_#1
              />
            </Col>
          </Form.Group>
          {/* sprint_20230508 #27 START */}
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>休止ユーザーデータ取得許可</Col>
            <Col sm={7}>
              <SelectBox
                name="dormantUserDataAcquisitionPermissionFlag"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.DORMANT_USER_DATA_ACQUISITION_PERMISSION_FLAG}
                value={dormantUserDataAcquisitionPermissionFlag}
                disabled={parseInt(serviceType, 10) === 2}
              />
            </Col>
          </Form.Group>
          {/* sprint_20230508 #27 END */}
          {/* STEP13.0.0 TAS-21617 START */}
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>ビデオ完了しきい値</Col>
            <Col sm={4}>
              <InputGroup size="sm">
                <FormControl
                  name="videoEndThreshold"
                  component="input"
                  type="number"
                  min={0}
                  max={100}
                  onChange={handleChangeForVideoEndThreshold}
                  value={videoEndThreshold}
                />
                <InputGroup.Text>%</InputGroup.Text>
              </InputGroup>
            </Col>
          </Form.Group>
        </>
      ) : (rootFlag && mode === MODE.EDIT_MODE && !isContentDistributionService) && (
        <>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>ドキュメント印刷許可</Col>
            <Col sm={7}>
              <SelectBox
                name="documentPrintingPermission"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.DOCUMENT_PRINTING_PERMISSION}
                value={documentPrintingPermission}
                disabled={(parseInt(serviceType, 10) === 2) || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>ドキュメントダウンロード許可</Col>
            <Col sm={7}>
              <SelectBox
                name="documentDownloadPermission"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.DOCUMENT_DOWNLOAD_PERMISSION}
                value={documentDownloadPermission}
                disabled={(parseInt(serviceType, 10) === 2) || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>個人設定編集表示</Col>
            <Col sm={7}>
              <SelectBox
                name="personalSettingsEditDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={personalSettingsEditDisplay}
                parse={(value) => value === 'true'}
                disabled={(parseInt(serviceType, 10) === 2) || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>進捗状況表示</Col>
            <Col sm={7}>
              <SelectBox
                name="progressStatusDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={progressStatusDisplay}
                parse={(value) => value === 'true'}
                disabled={(parseInt(serviceType, 10) === 2) || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>学習履歴表示</Col>
            <Col sm={7}>
              <SelectBox
                name="learningHistoryDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={learningHistoryDisplay}
                parse={(value) => value === 'true'}
                disabled={(parseInt(serviceType, 10) === 2) || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>メッセージ表示</Col>
            <Col sm={7}>
              <SelectBox
                name="messageDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={messageDisplay}
                parse={(value) => value === 'true'}
                disabled={(parseInt(serviceType, 10) === 2) || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>パスワードリセットメッセージ表示</Col>
            <Col sm={7}>
              <SelectBox
                name="passwordResetMessageDisplay"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABEL_DISABLE_DISPLAY}
                value={passwordResetMessageDisplay}
                disabled={(parseInt(serviceType, 10) === 2) || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>ビデオ先送り禁止</Col>
            <Col sm={7}>
              <SelectBox
                name="videoForwardingProhibited"
                onChange={handleChangeForServiceSetting}
                data={SELECT_BOX_DATA.AVAILABLE_DISABLE_USAGE_BOOLEAN_VALUE}
                value={videoForwardingProhibited}
                disabled={(parseInt(serviceType, 10) === 2) || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
           {/* STEP13.0.0 TAS-23260 START */}
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>
              バックグラウンド再生フラグ
            </Col>
            <Col sm={7}>
              <SelectBox
                name="backgroundVideoPlaybackFlag"
                onChange={handleChangeForServiceSetting}
                data={
                  SELECT_BOX_DATA.BACKGROUND_VIDEO_PLAYBACK_FLAG
                }
                value={backgroundVideoPlaybackFlag}
                disabled={parseInt(serviceType, 10) === 2 || isDisableByCustomizeSuf}
              />
            </Col>
          </Form.Group>
            {/* STEP13.0.0 TAS-23260 END */}
          <Form.Group className="form-info margin-top-10">
            <Col
              sm={{
                span: 3,
                offset: 1
              }}
              as={Form.Label}>ビデオ完了しきい値</Col>
            <Col sm={4}>
              <InputGroup size="sm">
                <FormControl
                  name="videoEndThreshold"
                  component="input"
                  type="number"
                  min={0}
                  max={100}
                  onChange={handleChangeForVideoEndThreshold}
                  value={videoEndThreshold}
                />
                <InputGroup.Text>%</InputGroup.Text>
              </InputGroup>
            </Col>
          </Form.Group>
        </>
      )}
      {/* STEP13.0.0 TAS-21617 END */}
      {/* sprint_20230403 #4 END */}
      {/* // Step SAML START */}
      {
        mode === MODE.EDIT_MODE && !isContentDistributionService && (
          <>
            <Form.Group className="form-info margin-top-10">
              <Col
                as={Form.Label}
                sm={{
                  span: 3,
                  offset: 1
                }}>シングルサインオン</Col>
              <Col sm={7}>
                <Col as={Form.Label} sm={4} className="padding-left-right-clear">利用有無</Col>
                <Col sm={8} className="padding-left-right-clear">
                  <SelectBox
                    name="usageSettingSaml"
                    onChange={handleChangeForUsageSetting}
                    data={SELECT_BOX_DATA.AVAILABLE_DISABLE_USAGE}
                    value={usageSettingInfo.usageSettingSaml}
                  />
                </Col>
              </Col>
            </Form.Group>
            {!isDisableSamlUsageSetting && (
              <Form.Group className="margin-top-10 margin-bottom-0 form-info">
                <Col
                  as={Form.Label}
                  sm={{
                    span: 3,
                    offset: 1
                  }}
                  className="padding-left-5">
                  <a role="presentation" className={this.state.openOrCloseStyleForSamlSetting} onClick={this.hanleOpenAndCloseSamlSetting}>
                    シングルサインオン設定
                  </a>
                </Col>
              </Form.Group>
            )}
            {!this.state.isClosedSamlSetting && !isDisableSamlUsageSetting && (
              <>
                <Form.Group className="form-info margin-top-10">
                  <Col
                    sm={{
                      span: 10,
                      offset: 2
                    }}
                    className="form-label">
                    IdP側設定内容
                  </Col>
                  <Col sm={12} className="form-label">
                    <Col
                      sm={{
                        span: 2,
                        offset: 2
                      }}
                      className="form-label">
                      メタデータXML
                    </Col>
                    <Col sm={5}>
                      <FormControlValidate
                        label="メタデータXML"
                        type="text"
                        name="xmlUploadFile"
                        className="margin-bottom-10"
                        value={fileName || ''}
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                            if (ref.value !== '') {
                              ref.validation();
                            }
                          }
                        }}
                        fileSize={fileSize}
                        validateType={VALIDATE_TYPE.XML_SIZE_AND_TYPE}
                        disabled={isDisableSamlUsageSetting} // #7514
                      />
                    </Col>
                    <Col sm={2}>
                      <FileUpload
                        inputId="upload-file-service"
                        onChange={this.props.handleFileChange}
                        fileName={this.props.xmlUploadFileName}
                        labelName="選択"
                        accept="text/xml"
                        disabled={isDisableSamlUsageSetting} // #7514
                      />
                    </Col>
                  </Col>
                </Form.Group>
                <Form.Group className="form-info margin-top-10">
                  <Col
                    sm={{
                      span: 10,
                      offset: 2
                    }}
                    className="form-label">
                    SP設定用情報
                  </Col>
                  <Col sm={12} className="form-label">
                    <Col
                      sm={{
                        span: 2,
                        offset: 2
                      }}
                      className="form-label">
                      エンティティID
                    </Col>
                    <Col sm={6} className="padding-top-10">
                      {usageSettingInfo.spEntityId}
                    </Col>
                    {usageSettingInfo.spEntityId && (
                      <Col sm={1} className="form-label">
                        <i className="bi bi-clipboard-fill cursor_pointer" onClick={() => copyTextToClipboard(usageSettingInfo.spEntityId)} />
                      </Col>
                    )}
                  </Col>
                  <Col sm={12} className="form-label">
                    <Col
                      sm={{
                        span: 2,
                        offset: 2
                      }}
                      className="form-label">
                      応答URL
                    </Col>
                    <Col sm={6} className="padding-top-10">
                      {usageSettingInfo.spReplyUrl}
                    </Col>
                    {usageSettingInfo.spReplyUrl && (
                      <Col sm={1} className="form-label">
                        <i className="bi bi-clipboard-fill cursor_pointer" onClick={() => copyTextToClipboard(usageSettingInfo.spReplyUrl)} />
                      </Col>
                    )}
                  </Col>
                  <Col sm={12} className="form-label">
                    <Col
                      sm={{
                        span: 2,
                        offset: 2
                      }}
                      className="form-label">
                      ログアウトURL
                    </Col>
                    <Col sm={6} className="padding-top-10">
                      {usageSettingInfo.spSloUrl}
                    </Col>
                    {usageSettingInfo.spSloUrl && (
                      <Col sm={1} className="form-label">
                        <i className="bi bi-clipboard-fill cursor_pointer" onClick={() => copyTextToClipboard(usageSettingInfo.spSloUrl)} />
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info margin-top-10">
                  <Col
                    sm={{
                      span: 10,
                      offset: 2
                    }}
                    className="form-label">
                    サービス設定用情報
                  </Col>
                  <Col sm={12} className="form-label">
                    <Col
                      sm={{
                        span: 2,
                        offset: 2
                      }}
                      className="form-label">
                      ログイン画面URL
                      <span className="required">&nbsp;(※)</span>
                    </Col>
                    <Col sm={7}>
                      <FormControlValidate
                        label="ログイン画面URL"
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                          }
                        }}
                        required
                        name="loginSuccessRedirectUrl"
                        value={usageSettingInfo.loginSuccessRedirectUrl}
                        onChange={handleChangeForUsageSetting}
                        type="text"
                        maxLength="1024" // sprint_20230403 #3
                        disabled={isDisableSamlUsageSetting} // #7514
                      />
                    </Col>
                  </Col>
                  <Col sm={12} className="form-label">
                    <Col
                      sm={{
                        span: 2,
                        offset: 2
                      }}
                      className="form-label">
                      ログアウト画面URL
                      <span className="required">&nbsp;(※)</span>
                    </Col>
                    <Col sm={7}>
                      <FormControlValidate
                        label="ログアウト画面URL"
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                          }
                        }}
                        required
                        name="logoutSuccessRedirectUrl"
                        value={usageSettingInfo.logoutSuccessRedirectUrl}
                        onChange={handleChangeForUsageSetting}
                        type="text"
                        maxLength="1024" // sprint_20230403 #3
                        disabled={isDisableSamlUsageSetting} // #7514
                      />
                    </Col>
                  </Col>
                  <Col sm={12} className="form-label">
                    <Col
                      sm={{
                        span: 2,
                        offset: 2
                      }}
                      className="form-label">
                      エラー画面URL
                      <span className="required">&nbsp;(※)</span>
                    </Col>
                    <Col sm={7}>
                      <FormControlValidate
                        label="エラー画面URL"
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                          }
                        }}
                        required
                        name="errorRedirectUrl"
                        value={usageSettingInfo.errorRedirectUrl}
                        onChange={handleChangeForUsageSetting}
                        type="text"
                        maxLength="1024" // sprint_20230403 #3
                        disabled={isDisableSamlUsageSetting} // #7514
                      />
                    </Col>
                  </Col>
                </Form.Group>
              </>
            )}
          </>
        )
      }
      {/* // Step SAML END */}
      <hr className="break-line"/>
    </>;
  }
}
export default ServiceUsageSetting;
